/**
 * 水保数联 — 品牌配色方案
 *
 * ⚠️ 本文件是配色方案的唯一数据源，所有组件必须引用此文件中的常量，
 *    禁止在组件中直接使用硬编码颜色值（语义性状态颜色除外）。
 *
 * 使用规范：
 *   - 装饰性元素（图标、统计数值、分类标识等）→ 使用 BRAND 系列
 *   - 语义性状态（成功/失败/警告/达标/等级）→ 使用 SEMANTIC 系列
 *   - 中性色（背景、文字、边框）→ 使用 NEUTRAL 系列
 */

// ============================================================
// 品牌色系 — 用于所有装饰性、交互性、标识性元素
// ============================================================
export const BRAND = {
  /** 主色 — 按钮、链接、图标、统计数值、分类标识、高亮元素 */
  PRIMARY: '#1890ff',
  /** 主色 Hover 状态 */
  PRIMARY_HOVER: '#40a9ff',
  /** 主色渐变终点 — 登录/注册页背景渐变 */
  PRIMARY_DARK: '#096dd9',
  /** 深蓝 — 顶栏 Header 背景 */
  HEADER: '#1e3a8a',
} ;

// ============================================================
// 语义色系 — 仅用于有实际语义的状态标识
// ============================================================
export const SEMANTIC = {
  /** 成功/正向 — 已上线、达标、在职、评估等级"优" */
  SUCCESS: '#52c41a',
  /** 警告/中等 — 中等评估等级、待处理 */
  WARNING: '#faad14',
  /** 错误/差等 — 不达标、失败、评估等级"差" */
  ERROR: '#ff4d4f',
  /** 深红 — 不达标/负值提示（更强烈的否定语义） */
  ERROR_DARK: '#cf1322',
  /** 信息 — 同品牌主色，用于信息提示类 */
  INFO: '#1890ff',
} ;

// ============================================================
// 中性色系 — 背景、文字、边框、分割线
// ============================================================
export const NEUTRAL = {
  /** 页面主背景 */
  BG_PAGE: '#f0f2f5',
  /** 卡片/内容区背景 */
  BG_CARD: '#ffffff',
  /** 代码块/消息气泡背景 */
  BG_CODE: '#f5f5f5',
  /** 表格头部背景 */
  BG_TABLE_HEAD: '#fafafa',
  /** 分割线/边框 */
  BORDER: '#f0f0f0',
  /** 表格边框 */
  BORDER_TABLE: '#e8e8e8',
  /** 占位色 — 空状态、未上线标签 */
  PLACEHOLDER: '#d9d9d9',
  /** 主文字色 */
  TEXT_PRIMARY: '#262626',
  /** 次要文字色 — 段落描述 */
  TEXT_SECONDARY: '#666666',
  /** 辅助文字色 — 底部信息、版权 */
  TEXT_TERTIARY: '#999999',
  /** 版权文字色 */
  TEXT_COPYRIGHT: '#8c8c8c',
} ;

// ============================================================
// 阴影
// ============================================================
export const SHADOW = {
  HEADER: '0 2px 8px rgba(0,0,0,0.1)',
  SIDER: '2px 0 8px rgba(0,0,0,0.05)',
  CARD: '0 1px 2px 0 rgba(0,0,0,0.03)',
  CARD_HOVER: '0 4px 12px rgba(0,0,0,0.1)',
  LOGIN_CARD: '0 10px 40px rgba(0,0,0,0.2)',
} ;

// ============================================================
// Ant Design 主题配置 — 用于 ConfigProvider
// ============================================================
export const ANT_THEME = {
  token: {
    colorPrimary: BRAND.PRIMARY,
    colorSuccess: SEMANTIC.SUCCESS,
    colorWarning: SEMANTIC.WARNING,
    colorError: SEMANTIC.ERROR,
    colorInfo: SEMANTIC.INFO,
    colorBgLayout: NEUTRAL.BG_PAGE,
    colorBgContainer: NEUTRAL.BG_CARD,
    colorText: NEUTRAL.TEXT_PRIMARY,
    colorTextSecondary: NEUTRAL.TEXT_SECONDARY,
    colorTextTertiary: NEUTRAL.TEXT_TERTIARY,
    colorBorder: NEUTRAL.BORDER,
    borderRadius: 8,
  },
} ;